module.exports = __webpack_public_path__ + "img/robo-hi.4206e94.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/robo-hi.png
// module id = KJHV
// module chunks = 1